import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import { DATE_INTL_FORMAT_MONTH_TEXT } from 'src/comps/DateIntl/constants'

import DateIntl from 'src/comps/DateIntl'
import InfoIcon from 'client/icons/Info'
import ListItem from 'src/comps/ListItem'
import Price from 'client/components/Price'

import { ConditionsMessage, ConditionsMessageTitle } from './styles'

const PaymentChangeConditions = ({ sellingRate, cancellationDate, payNow }) => {
  if (!cancellationDate) {
    return null
  }

  if (cancellationDate && payNow > 0 && payNow < sellingRate) {
    return (
      <ConditionsMessage>
        <ConditionsMessageTitle>
          <InfoIcon />
          <FormattedMessage id="global.change-conditions" />
        </ConditionsMessageTitle>
        <FormattedMessage id="payment.using-payment-implies-changes" />
        <ListItem>
          <FormattedMessage id="payment.pay-now-total-amount" />
        </ListItem>
        <ListItem>
          <FormattedMessage
            id="payment.cancel-for-free-slf"
            values={{
              amount: <Price amount={payNow} />,
              date: <DateIntl value={cancellationDate} format={DATE_INTL_FORMAT_MONTH_TEXT} />,
            }}
          />
        </ListItem>
      </ConditionsMessage>
    )
  }

  return (
    <ConditionsMessage>
      <ConditionsMessageTitle>
        <InfoIcon />
        <FormattedMessage id="global.change-conditions" />
      </ConditionsMessageTitle>
      <FormattedMessage id="payment.using-payment-implies-changes" />
      <ListItem>
        <FormattedMessage id="payment.pay-now-total-amount" />
      </ListItem>
      <ListItem>
        <FormattedMessage
          id="payment.cancel-for-free-nor"
          values={{
            date: <DateIntl value={cancellationDate} format={DATE_INTL_FORMAT_MONTH_TEXT} />,
          }}
        />
      </ListItem>
    </ConditionsMessage>
  )
}

PaymentChangeConditions.propTypes = {
  sellingRate: PropTypes.number,
  cancellationDate: PropTypes.string,
  payNow: PropTypes.number,
}

export default PaymentChangeConditions
